const templateProps = (route) => ({
  templateID: route.params.templateID,
  isDesign: false,
})

const TemplateNewForm = () => import('src/pages/Template/New.vue')
const TemplateCloneForm = () => import('src/pages/Template/Clone.vue')
const TemplatePrintPage = () => import('src/pages/Template/Print.vue')
const TemplateLayout = () => import('src/pages/Template/Layout.vue')

export default [
  {
    path: '/templates',
    component: TemplateLayout,
    redirect: '/templates/new',
    children: [
      {
        meta: {
          subheader: '동의서 형식 신규',
        },
        path: 'new',
        name: 'New Agreement Template',
        component: TemplateNewForm,
      },

      {
        meta: {
          subheader: '동의서 형식 편집',
        },
        path: ':templateID',
        name: 'Edit Agreement Template',
        component: TemplateCloneForm,
        props: templateProps,
      },
    ],
  },
  {
    meta: {
      subheader: '동의서 형식 인쇄',
    },
    path: '/print/:templateID',
    name: 'print Agreement Template',
    component: TemplatePrintPage,
    props: templateProps,
  },
]



// WEBPACK FOOTER //
// ./src/routes/template.js